import { Grid, Typography, Box } from "@mui/material";
import iconsHelpDesk from "../../../../assets/SvgIcons/icons-helpdesk.svg";
import iconstap from "../../../../assets/SvgIcons/iconstap.svg";
import iconswashroom from "../../../../assets/SvgIcons/icons-washroom.svg";
import iconscase from "../../../../assets/SvgIcons/icons-caseno.svg";
import iconscourtoom from "../../../../assets/SvgIcons/icons-courtroom.svg";
import iconswaiting from "../../../../assets/SvgIcons/icons-waiting.svg";
import Card from "../Common/Card";
import CustomBox from "../Common/CustomBox";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import LitigantBox from "../Common/LitigantBox";
import NavigationSemiDonnetChart from "../Common/NavigationSemiDonnetChart.js";
import DotMatrixChart from "../Common/DotMatrixChart/DotMatrixChart.js";
import { useState, useEffect } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import { BlockGridGraph, MiniBarTile } from "../BuildingBetterCourtsData.js";

const cardDataStatic = [
  {
    content: "Case No.",
    img: iconscase,
    statistics: "35%",
  },
  {
    content: "Washrooms",
    img: iconswashroom,
    statistics: "27%",
  },
  {
    content: "Helpdesk",
    img: iconsHelpDesk,
    statistics: "21%",
  },
  {
    content: "Waiting Area",
    img: iconswaiting,
    statistics: "32%",
  },
  {
    content: "Courtroom",
    img: iconscourtoom,
    statistics: "19%",
  },
  {
    content: "Water",
    img: iconstap,
    statistics: "22%",
  },
];

const faqsStatic = [
  {
    content: "How many entry points are there which have guide maps?",
    status: "0",
  },
  {
    content: "Is there a floor map and guide map in main building?",
    status: "Yes",
  },
  {
    content: "Does the court complex have board with directions?",
    status: "Yes",
  },
  {
    content: "Which language are the boards in? *",
    status: "No",
  },
  {
    content: "Is there help desk at entry?",
    status: "Yes",
  },
  {
    content: "Is there a person manning the desk?",
    status: "Yes",
  },
  {
    content: "Is there help desk inside the court complex?",
    status: "Yes",
  },
  {
    content: "Is there a person manning the desk?",
    status: "Yes",
  },
];

const DotMatrixChartData = [
  { label: "Lawyers", percentage: 33, color: "#FF6384" },
  { label: "Passersby", percentage: 17, color: "#36A2EB" },
  { label: "Vendors/Shops", percentage: 23, color: "#FFCE56" },
  { label: "Court Officials", percentage: 22, color: "#4BC0C0" },
  { label: "Guide Maps", percentage: 3, color: "#9966FF" },
  { label: "Others", percentage: 2, color: "#C9CBCF" },
];

const numberValue = (value) => {
  const normalized = Number.parseFloat(value);
  return Number.isFinite(normalized) ? normalized : 0;
};

export const Navigation = ({ selectedDistrict, dataState, dataDistrict }) => {
  const { theme, loader } = useCustomLogic();
  let isDistrict = selectedDistrict === "Select District";
  const [cardData, setCardData] = useState(cardDataStatic);
  const [faqs, setFaqs] = useState(faqsStatic);
  const [semiDonnet, setSemiDonnet] = useState([]);
  const [dotMatrix, setDotMatrix] = useState([]);
  const [dotMatKey, setDotMatKey] = useState(1);

  useEffect(() => {
    if (dataState && Object.keys(dataState).length > 0) {
      let arr = [
        dataState?.case_no ?? 0,
        dataState?.washroom ?? 0,
        dataState?.helpdesk ?? 0,
        dataState?.waiting ?? 0,
        dataState?.court ?? 0,
        dataState?.water ?? 0,
      ];
      setCardData(
        cardDataStatic.map((item, index) => ({
          ...item,
          statistics: `${arr[index]}%`,
        }))
      );

      setSemiDonnet([dataState.guide_maps_present, dataState.helpdesk_present]);
      setDotMatrix([
        dataState?.lawyer,
        dataState?.passerby,
        dataState?.vendor,
        dataState?.official,
        dataState?.map,
        dataState?.other,
      ]);
    }

    if (dataDistrict && Object.keys(dataDistrict).length > 0) {
      let arr = [
        dataDistrict?.entry_points_with_guided_maps,
        dataDistrict?.floor_map_present,
        dataDistrict?.direction_boards_present,
        dataDistrict?.direction_boards_languages,
        // dataDistrict?.helpdesk_present_court_complex,
        // dataDistrict?.helpdesk_person_present_court_comp,
        // dataDistrict?.helpdesk_present_main_court,
        // dataDistrict?.helpdesk_person_present_main_court,
        // dataDistrict?.no_of_entry_points,

        dataDistrict?.help_desk_at_entry,
        dataDistrict?.person_manning_entry_desk,
        dataDistrict?.help_desk_inside_court_complex,
        dataDistrict?.person_manning_inside_desk,
      ];
      setFaqs(faqsStatic.map((item, index) => ({ ...item, status: arr[index] })));
      let arr2 = [
        dataDistrict?.displayCaseNo ?? dataDistrict?.case_no,
        dataDistrict?.signageToilet ?? dataDistrict?.washroom,
        dataDistrict?.signageHelpdesk ?? dataDistrict?.helpdesk,
        dataDistrict?.signageWaiting ?? dataDistrict?.waiting,
        dataDistrict?.signageCourt ?? dataDistrict?.court,
        dataDistrict?.signageWater ?? dataDistrict?.water,
      ].map(numberValue);

      if (!isDistrict) {
        setCardData(
          cardDataStatic.map((item, index) => ({
            ...item,
            statistics: `${arr2[index]}%`,
          }))
        );

        // for district each district
        setDotMatrix([
          dataDistrict?.lawyerGuided ?? dataDistrict?.lawyer,
          dataDistrict?.askedPasserby ?? dataDistrict?.passerby,
          dataDistrict?.askedVendor ?? dataDistrict?.vendor,
          dataDistrict?.askedOfficial ?? dataDistrict?.official,
          dataDistrict?.guideMap ?? dataDistrict?.map,
          dataDistrict?.other,
        ]);
      }
    }
  }, [dataState, dataDistrict, selectedDistrict]);

  useEffect(() => {
    if (dotMatrix.length > 0) {
      dotMatFun();
      setDotMatKey(Math.random());
    }
  }, [dotMatrix]);

  const dotMatFun = () => {
    dotMatrix.map((item, index) => (DotMatrixChartData[index].percentage = numberValue(item)));
  };

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict && (
            <>
              <Typography variant="regular3" color="secondary.main">
                How easy is it to move within the court complex?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                An easily navigable court complex is one that has guide maps and help desks at the
                entry to the complex or in the main court building. Litigants were asked as to how
                they found their way within the court complex. They were also asked for suggestions
                to improve signages.
              </Typography>
            </>
          )}

          <CustomBox
            content={
              isDistrict
                ? "AVAILABILITY OF HELP FOR NAVIGATION:"
                : "Is it easy to move within the court complex?"
            }
            style={{
              fontSize: !isDistrict && "24px",
              padding: !isDistrict && "8px 13px",
              color: !isDistrict && theme.palette.common.black,
              backgroundColor: !isDistrict && "#e6ebf4",
            }}
          />
          {isDistrict ? (
            <Grid container>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                {
                  <NavigationSemiDonnetChart
                    color={"#00008B"}
                    percentage={semiDonnet[0] || 0}
                    text={"GUIDE MAPS"}
                  />
                }
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <NavigationSemiDonnetChart
                  color={"#FF0000"}
                  percentage={semiDonnet[1] || 0}
                  text={"HELPDESKS"}
                />
              </Grid>
            </Grid>
          ) : (
            // <></>
            <>
              {faqs &&
                faqs.map((elem, index) => {
                  return (
                    <FAQ
                      content={elem?.content}
                      status={elem?.status ?? 0}
                      isLastItem={index === faqs.length - 1}
                      fromNavigation={true}
                    />
                  );
                })}

              <Typography
                variant="body1"
                color={theme.palette.jaldi.gray}
                sx={{ margin: "35px 0px 15px 0px" }}
              >
                *This factor was not taken into consideration for scoring.
              </Typography>
            </>
          )}

          <LitigantBox mt={!isDistrict && "26px"} mb={!isDistrict && "0px"} />
          <CustomBox content="HOW DID LITIGANTS LOCATE THE COURTROOM?" mt={!isDistrict && "0px"} />

          {/* {dotMatrix.length > 0 && <DotMatrixChart key={dotMatKey} data={DotMatrixChartData} />} */}
          <Box sx={{ display: "grid", gap: "10px", p: "30px" }}>
            {DotMatrixChartData.map((data) => (
              <Box
                sx={{
                  p: "7px",
                  border: `1px solid ${data?.color}`,
                  borderRadius: "3px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "5px",
                  height: "35px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <span className="dot-legend" style={{ backgroundColor: data?.color }}></span>
                  <p>{data?.label}</p>
                </Box>
                <p>{data?.percentage}%</p>
              </Box>
            ))}
          </Box>

          {/* <Box sx={{ height: "190px", margin: "20px 0px", background : 'khaki' }}></Box> */}
          <LitigantBox mt={!isDistrict && "26px"} mb={!isDistrict && "0px"} />

          <CustomBox
            content="LITIGANTS' SUGGESTIONS FOR BETTER SIGNAGE:"
            mt={!isDistrict && "0px"}
          />
          <Grid container spacing={2} sx={{ padding: "0 !important" }}>
            {cardData &&
              cardData.map((item, index) => (
                <Grid item xs={12} md={6} lg={6} key={index}>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <BlockGridGraph percentage={item?.statistics} color="#00bcd4" />
                    <Card content={item.content} imgSrc={item.img} statistics={item.statistics} />
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      )}
    </>
  );
};
